/**
 * Page Hero partial.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @copyright 2024 Simon Lagerlöf
 * @since 1.0.0
 */

import shrinkTextToFit from '../utils/shrinkTextToFit';

export default function partialHero() {
  const hero = document.querySelector('header.page-hero');

  const titles = hero?.querySelectorAll<HTMLElement>(
    ':is(h1.page-hero__title,span.page-hero__overtitle)',
  );

  if (
    !(hero instanceof HTMLElement) ||
    !(titles instanceof NodeList)
  ) {
    return;
  }

  for (const title of titles) {
    shrinkTextToFit(hero, title);
  }

  window.addEventListener('resize', () => {
    for (const title of titles) {
      shrinkTextToFit(hero, title);
    }
  });
}
